// @ts-ignore
import { all } from 'redux-saga/effects';
import { cleanModules } from './reducers';

const sagas = {
    'Auth/saga': require('./source/Auth/saga'),
    'Categories/saga': require('./source/Categories/saga'),
    'Colors/saga': require('./source/Colors/saga'),
    'Countries/saga': require('./source/Countries/saga'),
    'Customers/saga': require('./source/Customers/saga'),
    'Designs/saga': require('./source/Designs/saga'),
    'Documents/saga': require('./source/Documents/saga'),
    'Internalization/saga': require('./source/Internalization/saga'),
    'Items/saga': require('./source/Items/saga'),
    'ItemSpecifications/saga': require('./source/ItemSpecifications/saga'),
    'Orders/saga': require('./source/Orders/saga'),
    'Packages/saga': require('./source/Packages/saga'),
    'Salesman/saga': require('./source/Salesman/saga'),
    'Sizes/saga': require('./source/Sizes/saga'),
    'SizingRanges/saga': require('./source/SizingRanges/saga'),
    'Skus/saga': require('./source/Skus/saga'),
    'SkuGenders/saga': require('./source/SkuGenders/saga'),
    'Sports/saga': require('./source/Sports/saga'),
    'Transactions/saga': require('./source/Transactions/saga'),
    'User/saga': require('./source/User/saga'),
    'Locations/saga': require('./source/Locations/saga'),
    'Wholesaler/saga': require('./source/Wholesaler/saga'),
};

export default function* rootSaga(params) {
    const Sagas = cleanModules(sagas).reduce((bag, saga) => {
        try {
            if (saga.default) {
                bag.push(saga.default(params));
            } else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error('No default saga exported');
            }
        } catch (e) {
            console.warn(`[WARN]: Saga '${saga.__FILE__}' couldn't register! {\n\t${e.message}\n}`);
        }

        return bag;
    }, []);

    yield all(Sagas);
}
